import { Share2, Copy } from "lucide-react";
import { Button } from "@/components/ui/button";
import { shareBadgeText, shareBadgeUrl } from "@/lib/badges";
import { toast } from "sonner";

export default function ShareBadgeButton({ badge, userName, path = "/student/badges", size = "sm" }) {
  const text = shareBadgeText(badge, userName);
  const url = shareBadgeUrl(path);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(`${text}\n${url}`);
      toast.success("Lien copié dans le presse-papiers");
    } catch {
      toast.error("Impossible de copier");
    }
  };

  const share = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title: badge?.title, text, url });
        return;
      } catch {
        /* user cancelled */
      }
    }
    copy();
  };

  return (
    <div className="flex gap-1">
      <Button type="button" variant="outline" size={size} className="gap-1.5 rounded-full" onClick={share}>
        <Share2 className="w-3.5 h-3.5" /> Partager
      </Button>
      <Button type="button" variant="ghost" size="icon" className="h-8 w-8" onClick={copy} title="Copier le lien">
        <Copy className="w-3.5 h-3.5" />
      </Button>
    </div>
  );
}